interface PharmacySvgProps {
  className?: string;
}

export function RetailPharmacySvg({ className }: PharmacySvgProps) {
  return (
    <svg viewBox="0 0 74 73" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        fill="currentColor"
        d="M73.365 30.3887L70.355 34.0672L64.7323 29.4667V72.6348H9.27351V29.4621L3.64527 34.0672L0.635254 30.3887L37.0006 0.634766L73.365 30.3887ZM13.6391 25.8903H14.0271V67.8811H59.9787V25.8903H60.3612L36.9997 6.77643L13.6391 25.8903Z"
      />
    </svg>
  );
}

export function MailOrderPharmacySvg({ className }: PharmacySvgProps) {
  return (
    <svg viewBox="0 0 78 65" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        fill="currentColor"
        d="M77.8571 0.941177H27.5714V14.6555H14.4377L8.99768 32.9412H0.142822V55.6932H9.29482C9.29482 55.7297 9.28568 55.7617 9.28568 55.7983C9.28568 60.8406 13.3863 64.9412 18.4285 64.9412C23.4708 64.9412 27.5714 60.8406 27.5714 55.7983C27.5714 55.7617 27.5623 55.7297 27.5623 55.6932H50.4423C50.4377 55.7297 50.4285 55.7617 50.4285 55.7983C50.4285 60.8406 54.5291 64.9412 59.5714 64.9412C64.6137 64.9412 68.7143 60.8406 68.7143 55.7983C68.7143 55.7617 68.7051 55.7297 68.7051 55.6932H77.8571V0.941177ZM17.848 19.2269H27.5714V32.9412H13.7657L17.848 19.2269ZM18.4285 60.3697C15.9097 60.3697 13.8571 58.3172 13.8571 55.7983C13.8571 53.2795 15.9097 51.2269 18.4285 51.2269C20.9474 51.2269 23 53.2795 23 55.7983C23 58.3172 20.9474 60.3697 18.4285 60.3697ZM59.5714 60.3697C57.0525 60.3697 55 58.3172 55 55.7983C55 53.2795 57.0525 51.2269 59.5714 51.2269C62.0903 51.2269 64.1428 53.2795 64.1428 55.7983C64.1428 58.3172 62.0903 60.3697 59.5714 60.3697ZM73.2857 51.1217H67.384C65.784 48.4612 62.8994 46.6555 59.5714 46.6555C56.2434 46.6555 53.3588 48.4612 51.7588 51.1217H26.2411C24.6411 48.4612 21.7565 46.6555 18.4285 46.6555C15.1005 46.6555 12.216 48.4612 10.616 51.1217H4.71425V37.5126H32.1428V5.51261H73.2857V51.1217Z"
      />
    </svg>
  );
}
